import { FieldLabel } from '../../../shared/ui/field-label';
import { Hint } from '../../../shared/ui/hint';
import { Select } from '../../../shared/ui/select';
import { methodName, type TSourceAuthMethod } from '../../../entities/source';

interface IMethodFieldProps {
  id: string;
  methods: readonly TSourceAuthMethod[];
  value: string;
  onChange: (next: string) => void;
}

// Only asked when there is a choice: with one method the server infers it, and so does the reader.
export const MethodField = ({ id, methods, value, onChange }: IMethodFieldProps) =>
  methods.length > 1 ? (
    <div>
      <FieldLabel htmlFor={id}>Checked by</FieldLabel>
      <Select
        id={id}
        value={value}
        onChange={onChange}
        options={methods.map((method) => ({ value: method.id, label: methodName(method) }))}
      />
      <Hint>
        The source checks {methods.length} kinds of secret; this one works only for the one picked.
      </Hint>
    </div>
  ) : null;
